import { Component } from '@angular/core';
import { SplitButtonElement } from '../../../components/elements/splitbutton/splitbutton.component';
import { IQuestionnaireWorkflowItem } from '@interfaces/interfaces';
import { WorkflowStatus } from '@api/projects/interfaces';
@Component({
	selector: 'app-button-function-showcase',
	templateUrl: './button-function-showcase.component.html',
	styleUrls: ['./../../../workflow/components/navigator/wizard-view/wizard-view.component.scss']
})
export class ButtonFunctionShowcaseComponent {
	public buttonList = [
		{
			name: 'Speichern',
			description: 'Speichern eines Datensatzes, zum Beispiel bei der Erstellung eines Teilnehmers',
			button: [{
				title: 'actions.save',
				type: 'primary',
				icon: 'save',
			}],
			size: 'default',
		},
		{
			name: 'Bearbeiten',
			description: 'Bearbeiten eines Datensatzes, zum Beispiel bei die Daten eines Teilnehmers',
			button: [{
				title: 'actions.edit',
				type: 'primary',
				icon: 'edit',
			}],
			size: 'default',
		},
		{
			name: 'Abbrechen',
			description: 'Abbrechen einer Aktion',
			button: [{
				title: 'actions.cancel',
				type: 'default',
				icon: 'x',
			}],
			size: 'default',
		},
		{
			name: 'Löschen',
			description: 'Löschen eines Datensatzes, zum Beispiel einen Teilnehmer',
			button: [{
				title: 'actions.delete',
				type: 'default',
				icon: 'trash',
			}],
			size: 'default',
		},
		{
			name: 'Fragebogen Starten / Fortsetzen / Anzeigen',
			description: 'Button zum Starten / Fortsetzen / Anzeigen eines Workflowschritts abhängig von dessen Status',
			noIcon: true,
			button: [
				{
					title: 'actions.continue',
					type: 'primary',
					icon: 'list',
				},
				{
					title: 'actions.show',
					type: 'primary',
					icon: 'list',
				},
				{
					title: 'workflow.resetData',
					type: 'primary',
					icon: 'trash',
					hasDivider: true,
				}
			],
			size: 'large'
		},
		{
			name: 'Zurück zur Workflowschritt - Detailseite',
			description: 'Mit diesem Button kehrt der Benutzer zur Workflowschritt - Detailseite zurück',
			button: [{
				title: 'actions.show_workflow',
				type: 'default',
				icon: 'chevrons-left',
			}],
			size: 'default',
		},
		{
			name: 'Workflowschritt Bearbeitung beenden',
			description: 'Mit diesem Button kehrt der Benutzer zur Workflowschritt - Detailseite zurück',
			button: [{
				title: 'workflow.end',
				type: 'primary',
				icon: 'check',
			}],
			size: 'default',
		},
	];

	public resetButton: SplitButtonElement = {
		title: 'workflow.resetData',
		type: 'primary',
		icon: 'trash',
		hasDivider: true,
	};
	public workflowStartedContinueSplitButton: SplitButtonElement[];
	public workflowFinishedSplitButton: SplitButtonElement[];
	public distractionFreeWizardIcon = 'trello';
	public compactViewIcon = 'book-open';
	public workflowStartedString: string;
	public workflowStartedContinue: string;
	public selectedViewMode = 'compact';
	questionnaireWorkflowItem: IQuestionnaireWorkflowItem = {
		id: 'test',
		showOverview: true,
		name: 'Showcase 1',
		description: 'Showcase Test nicht gestarted',
		groups: [],
		category: 'Questionnaire',
		type: 'Questionnaire',
	};
	workflowStatus: WorkflowStatus = {
		pid: 'test',
		status: {
			test: {
				completed: false,
				started: true,
			}
		}
	};

	constructor() {
		this.workflowStartedString = this.workflowStatus.status[this.questionnaireWorkflowItem.id]?.started ?
			'status.started' :
			'status.unstarted';
		this.workflowStartedContinue = this.workflowStatus.status[this.questionnaireWorkflowItem.id]?.started ?
			'actions.continue' :
			'actions.start';
		this.initSplitButtons();
	}

	public initSplitButtons(): void {
		//Splitbuttons die für beide Karten verfügbar sind
		const showOverviewInCompactButton: SplitButtonElement = {
			title: 'workflow.show_OverviewInCompact',
			type: 'primary',
			icon: this.compactViewIcon,
		};
		const showOverviewInWizardButton: SplitButtonElement = {
			title: 'workflow.show_OverviewInWizard',
			type: 'primary',
			icon: this.distractionFreeWizardIcon,
		};
		const resetButton: SplitButtonElement = {
			title: 'workflow.resetData',
			type: 'primary',
			icon: 'trash',
			hasDivider: true,
		};

		//SplitButtons Erstellen, zuerst für Starten und fortsetzen.
		this.workflowStartedContinueSplitButton = [];
		this.workflowStartedContinueSplitButton.push({
			title: this.workflowStartedContinue,
			type: 'primary',
		});
		//Kompakt Modus ausgewählt
		if (this.selectedViewMode === 'compact') {
			if (this.workflowStartedString === 'status.unstarted') {
				this.workflowStartedContinueSplitButton.push({
					title: 'workflow.startInCompact',
					type: 'primary',
					icon: this.compactViewIcon,
				});
			}
			else if (this.workflowStartedString === 'status.started'
				&& !this.workflowStatus?.status[this.questionnaireWorkflowItem.id]?.completed) {
				this.workflowStartedContinueSplitButton.push({
					title: 'workflow.continueInCompact',
					type: 'primary',
					icon: this.compactViewIcon,
				});
			}
			if (this.questionnaireWorkflowItem?.showOverview) {
				this.workflowStartedContinueSplitButton.push(showOverviewInCompactButton);
			}
		}
		//Ablenkungsfreier Wizard Ausgewählt
		else if (this.selectedViewMode === 'wizard') {
			if (this.workflowStartedString === 'status.unstarted') {
				this.workflowStartedContinueSplitButton.push({
					title: 'workflow.startInWizard',
					type: 'primary',
					icon: this.distractionFreeWizardIcon,
				});
			}
			else if (this.workflowStartedString === 'status.started'
				&& !this.workflowStatus?.status[this.questionnaireWorkflowItem.id]?.completed) {
				this.workflowStartedContinueSplitButton.push({
					title: 'workflow.continueInWizard',
					type: 'primary',
					icon: this.distractionFreeWizardIcon,
				});
			}
			if (this.questionnaireWorkflowItem?.showOverview) {
				this.workflowStartedContinueSplitButton.push(showOverviewInWizardButton);
			}
		}
		if (this.workflowStartedString === 'status.started' || this.workflowStatus?.status[this.questionnaireWorkflowItem.id]?.completed) {
			this.workflowStartedContinueSplitButton.push(resetButton);
		}

		//Schritt beendet Button
		this.workflowFinishedSplitButton = [];
		if (this.questionnaireWorkflowItem.showOverview) {
			this.workflowFinishedSplitButton.push({
				title: 'workflow.show_Overview',
				type: 'primary',
			});
		}
		else {
			this.workflowFinishedSplitButton.push({
				title: 'workflow.show',
				type: 'primary',
			});
		}
		//Kompaktmouds ausgewählt
		if (this.selectedViewMode === 'compact') {
			if (this.questionnaireWorkflowItem.showOverview) {
				this.workflowFinishedSplitButton.push({
					title: 'workflow.show_OverviewInCompact',
					type: 'primary',
					icon: this.compactViewIcon,
				});
			}
			this.workflowFinishedSplitButton.push({
				title: 'workflow.showInCompact',
				type: 'primary',
				icon: this.compactViewIcon,
			});
		}
		//Anlenkungsfreier Wizard ausgewählt
		if (this.selectedViewMode === 'wizard') {
			if (this.questionnaireWorkflowItem.showOverview) {
				this.workflowFinishedSplitButton.push({
					title: 'workflow.show_OverviewInWizard',
					type: 'primary',
					icon: this.distractionFreeWizardIcon,
				});
			}
			this.workflowFinishedSplitButton.push({
				title: 'workflow.showInWizard',
				type: 'primary',
				icon: this.distractionFreeWizardIcon,
			});
		}
		this.workflowFinishedSplitButton.push(resetButton);
	}
}
